import { TextField } from '@material-ui/core';
import React from 'react'
import styles from './item.module.css';
import IconButton from '@material-ui/core/IconButton'
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';

const Item = (props) => {
    return (
        <div className={styles.container}>
            <h4># {props.index + 1}</h4>
            <TextField
                variant="outlined"
                className={styles.textField}
                label="Name"
                value={props.item.name}
                onChange={(e) => props.onNameChange(e.target.value)}

                error={props.error && props.error.name}
                helperText={props.error && props.error.name}
            />

            <TextField
                variant="outlined"
                className={styles.textField}
                label="Godown Barcode"
                disabled
                value={props.item.godown_barcode}
                onChange={(e) => props.onCodeChange(e.target.value)}
            /> 

            <IconButton onClick={props.onDelete}>
                <DeleteRoundedIcon />
            </IconButton>
        </div>
    )
}

export default Item;